import type {DefaultOptions} from '../../../types';
import type {NumberValueEditorOptions} from './types';
import type {NumberValueEditorLocalizations} from './types';


/**
 * @ngdoc constant
 * @name NUMBER_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.number
 *
 * @description
 * For description see {@link NumberValueEditorOptions}
 *
 * Default value:
 * ```javascript
 *  {
 *      decimal: false,
 *      step: 1,
 *      hideSpinners: false
 *  }
 * ```
 */
export const NUMBER_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<NumberValueEditorOptions> = {
    decimal: false,
    step: 1,
    hideSpinners: false
};


/**
 * @ngdoc constant
 * @name NUMBER_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.number
 *
 * @description
 * ```
 * {
 *      description: ''
 * }
 * ```
 */
export const NUMBER_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<NumberValueEditorLocalizations>({
    description: ''
});